module.exports = __webpack_public_path__ + "img/title-logotype.16e82dfb.png";